"use client";
export * from "./faq/faq.component";
export * from "./header/header.component";
export * from "./how-it-works/how-it-works.component";
export * from "./landing-page/landing-page.component";
export * from "./language-switcher/language-switcher.component";
export * from "./login-flow";
export * from "./register-flow";
export * from "./required-documents/required-documents.component";
export * from "./welcome-section/welcome-section.component";
export * from "./who-can-apply/who-can-apply.component";
